import { apiFetch } from "./api";

export const saveRating = async (values, quarterly, meetingDate) => {
    const obj = {
        method: 'POST',
        body: {
            ratings: values,
            option: 'save_edit_ratings',
            quarterly: quarterly,
            meeting_date: meetingDate
        }
    }

    const response = await apiFetch(obj);

    return response;
};
